export default __webpack_public_path__ + "static/media/Chariot-LogoMain.910d0bd2.png";